<template lang='pug'>
  div(:class='[$style[`cc-input`], $style[beforeIcon ? `has-before-icon` : ``], $style[errorValue ? `has-error` : ``], $style[resetButton ? `has-resetBtn` : ``]]')

    span(
      v-if='errorRegex'
      v-html='errorRegexInfo'
      :class='$style[`cc-input-regex-error`]')

    span(
      v-show='beforeIcon'
      :class='$style[`cc-input-before-icon`]')
      IconUser(
        v-if='beforeIcon === `user`'
        :size='24'
        :color='beforeIconColor')
      IconMail(
        v-if='beforeIcon === `mail`'
        :size='24'
        :color='beforeIconColor')
      IconPassWord(
        v-if='beforeIcon === `password`'
        :size='24'
        :color='beforeIconColor')
      IconConfirm(
        v-if='beforeIcon === `confirm`'
        :size='24'
        :color='beforeIconColor')
      IconGender(
        v-if='beforeIcon === `gender`'
        :size='24'
        :color='beforeIconColor')
      IconSearch(
        v-if='beforeIcon === `search`'
        :size='24'
        :color='beforeIconColor')

    div(v-if='emojiButton' :class='$style[`cc-input-emoji`]' v-on-clickaway='handleEmojiOnBlur')
      perfect-scrollbar.emoji-selector(v-show='showEmoji' :class='$style[`cc-emoji-selector`]' ref='customScrollBarDom')
        div(:class='$style[`cc-emoji-selector-wrap`]' ref='customScrollBarDom')
          div(:class='$style[`cc-selector-wrap-type`]')
            span(:class='$style[`cc-selector-wrap-category`]')!= '表情'
            ul(:class='$style[`cc-emoji-selector-ul`]')
              li(v-for='(items, index) in EMOJI.face' :key='index' :class='$style[`cc-emoji-selector-li`]' @click='handleAppendEmojiOnClick(items)') {{ items }}

          div(:class='$style[`cc-selector-wrap-type`]')
            span(:class='$style[`cc-selector-wrap-category`]')!= '人物與手勢'
            ul(:class='$style[`cc-emoji-selector-ul`]')
              li(v-for='(items, index) in EMOJI.action' :key='index' :class='$style[`cc-emoji-selector-li`]' @click='handleAppendEmojiOnClick(items)') {{ items }}

          div(:class='$style[`cc-selector-wrap-type`]')
            span(:class='$style[`cc-selector-wrap-category`]')!= '物品'
            ul(:class='$style[`cc-emoji-selector-ul`]')
              li(v-for='(items, index) in EMOJI.item' :key='index' :class='$style[`cc-emoji-selector-li`]' @click='handleAppendEmojiOnClick(items)') {{ items }}

      div(:class='[$style[`cc-input-emoji-switcher`], $style[!showEmoji ? `cc-no-active` : ``]]' @click='handleShowEmojiList')
        IconEmoji(v-if='showEmoji' :size='28')
        IconEmoji(v-else :size='28' :color='`#d0d0d0`')

    input(
      ref='inputer'
      :type='type'
      :placeholder='!plhShow ? `` : plh'
      :class='[$style[`cc-input-area`],$style[isDisabled ? `cc-input-disable` : ``]]'
      :disabled='isDisabled'
      @input='onInputChange($event.target.value)'
      @focus='onInputFocus'
      @blur='onInputBlur'
      @keypress.stop.prevent.enter='keyPressEnter')

    span(
      v-if='resetButton'
      v-show='changeValue'
      :class='$style[`cc-input-reset`]'
      @click='onInputResetClick')
      IconClose(:size='16' :color='`#98A1A1`')

</template>

<script>
import IconClose from '../../icon/Close';
import IconUser from '../../icon/User';
import IconMail from '../../icon/Mail';
import IconPassWord from '../../icon/Password';
import IconConfirm from '../../icon/Confirm';
import IconGender from '../../icon/Gender';
import IconEmoji from '../../icon/Emoji';
import IconSearch from '../../icon/Search';
import { mixin as clickaway } from 'vue-clickaway';

export default {
  components: {
    IconClose,
    IconUser,
    IconMail,
    IconPassWord,
    IconConfirm,
    IconGender,
    IconEmoji,
    IconSearch,
  },

  mixins: [clickaway],

  model: {
    prop: 'changeValue',
    event: 'input',
  },

  props: {
    isDisabled: {
      type: Boolean,
      default: false,
    },
    keyPressEnter: {
      type: Function,
      default: function () {},
    },
    defaultValue: {
      type: String,
      default: '',
    },
    changeValue: {
      type: String,
      default: '',
    },
    emojiButton: {
      type: Boolean,
      default: false,
    },
    resetButton: {
      type: Boolean,
      default: false,
    },
    beforeIcon: {
      type: String,
      default: '',
    },
    beforeIconSize: {
      type: Number,
      default: 20,
    },
    beforeIconColor: {
      type: String,
      default: '#000',
    },
    placeholder: {
      type: String,
      default: '',
    },
    errorValue: {
      type: Boolean,
      default: false,
    },
    errorRegex: {
      type: Boolean,
      default: false,
    },
    errorRegexInfo: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
  },

  data() {
    return {
      plh: this.placeholder,
      plhShow: true,
      showEmoji: false,
      isInputGetValue: false,
    };
  },

  mounted() {
    // this.$nextTick(() => {
    //   this.$refs.inputer.value = this.defaultValue;
    // })
    this.$refs.inputer.value = this.defaultValue;
  },

  methods: {
    forceResetValue() {
      this.$refs.inputer.value = '';
    },

    onInputResetClick() {
      this.$emit('input', '');
      this.$refs.inputer.value = '';
    },

    onInputChange(newValue) {
      // console.log('Input SearchBar onChange!!!', newValue);
      newValue ? this.isInputGetValue = true : this.isInputGetValue = false;
      this.$emit('input', newValue);
      this.$emit('clearErrorMsg', [false, false]);
    },

    onInputFocus() {
      if (this.isDisabled) { return; }
      this.plhShow = false;
    },

    onInputBlur() {
      if (this.isDisabled) { return; }
      this.plhShow = true;
    },

    // Emoji
    handleEmojiOnBlur() {
      this.showEmoji = false;
    },

    handleShowEmojiList() {
      this.showEmoji = !this.showEmoji;
    },

    handleAppendEmojiOnClick(emoji) {
      this.$refs.inputer.value = this.$refs.inputer.value + emoji;
      this.$emit('input', this.$refs.inputer.value);
      // this.nextTick += 1;
    },
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/common/input.scss';
</style>
